var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64291 8.82842L14.5222 3.93345C14.8274 3.62652 15 3.20731 15 2.7698V1.33416C15 0.433353 14.2853 0 13.4037 0H1.5963C0.714712 0 0 0.433353 0 1.33416V2.79558C0 3.20981 0.15385 3.60906 0.431432 3.91182L4.91426 8.80264C4.99891 8.89496 5.11695 8.94737 5.24149 8.9482L9.32626 8.95984C9.44429 8.96067 9.55826 8.91409 9.64291 8.82842Z",
    fill: "#4D70B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.047 8.90479V14.4086C5.047 14.6091 5.14794 14.7979 5.31318 14.906C5.40761 14.9684 5.51669 15 5.62577 15C5.70798 15 5.7902 14.9825 5.86672 14.9476L9.17165 13.4072C9.37841 13.3115 9.5111 13.1011 9.5111 12.869V8.90479H5.047Z",
    fill: "#4D70B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.cfdb0e38052462dbf060d5e87a3112e3.svg";
export { ForwardRef as ReactComponent };